// @noflow
import React from 'react'

import { Button } from '@/components/elements/atoms/Button'
import Card from '@/components/elements/atoms/Card/Card'
import Text from '@/components/elements/atoms/Text/Text'
import BoxBreakdownV2 from '@/components/elements/molecules/BoxBreakdownV2/BoxBreakdownV2'
import STYLES from '@/components/pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass'

type Props = {
  mfitbSavingsAmount: string
  cadence: number
  pouchSize: number
  pouchesPerDay: number
  mfitbPricePerWeek: string | number
  onClick: () => void
  disabled: boolean
}

const MFITBPlanCard = ({
  mfitbSavingsAmount,
  cadence,
  pouchSize,
  pouchesPerDay,
  mfitbPricePerWeek,
  onClick,
  disabled
}: Props): JSX.Element => {
  const namespace = 'account'
  return (
    <Card border="none" padding={24}>
      <div className={STYLES.cardContent}>
        <div className={STYLES.textSpacing}>
          <Text
            namespace={namespace}
            text={`price_sensitive_paused_page.options.mfitb_card.title`}
            variant="display20"
            margin={false}
            variables={{
              mfitbSavingsAmount: mfitbSavingsAmount
            }}
          />
          <Text
            namespace={namespace}
            text={`price_sensitive_paused_page.options.mfitb_card.subtitle`}
            margin={false}
          />
        </div>
        <div className={STYLES.boxBreakdown}>
          <BoxBreakdownV2
            cadence={cadence}
            pouchSize={pouchSize}
            pouchesPerDay={pouchesPerDay}
          />
        </div>
        <Text
          namespace={namespace}
          text={`price_sensitive_paused_page.options.mfitb_card.price`}
          variant="display16"
          margin={false}
          variables={{
            mfitbPricePerWeek: mfitbPricePerWeek
          }}
        />
        <Button
          onClick={onClick}
          typography={{
            namespace,
            text: `price_sensitive_paused_page.options.mfitb_card.cta`
          }}
          fullWidth
          identifier="price_sensitive_paused_page.mfitb_card.resume_cta"
          disabled={disabled}
        />
      </div>
    </Card>
  )
}

export default MFITBPlanCard
